import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  navHeight: 108,
  sectionPadding: "padding-top: 1.5em; padding-bottom: 1.5em;",
  fonts: {
    primary: "Inter, sans-serif",
    secondary: "TiemposHeadline",
  },
  layout: {
    contentWidth: 1236,
  },
  palette: {
    primary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#004914",
      light: "#F1F8F4",
      dark: "#113225",
    },
    secondary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#FFA800",
      light: "#F7F8F9",
      dark: "#D1EEDE",
    },
    tertiary: {
      main: "#36404B",
      light: "#F1F8F4",
      dark: "#FFCC6A",
    },
    text: {
      primary: "#191D23",
      secondary: "#F26B2A",
      content: "#64748B",
      /*content: "#000000",*/
      tertiary: "#1A2933",
      disabled: "#10355A",
      hint: "#10355A",
      light: "#FFFFFF",
      titles: "#191D23",
      black: "#0D0F11",
    },
    alternate: {
      main: "rgb(247, 249, 250)",
      dark: "#e8eaf6",
    },
  },
  typography: {
    fontFamily: `"DM Sans", "Open Sans", "Arial", sans-serif`,
  },
})

export default theme
